/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { RowNode } from 'ag-grid-community';
import { uniqueId } from 'lodash';
import { GridCellRendererComponent } from '../../cell-components/grid-component.interfaces';
import { GridSelection, GridSelector } from './grid-selectable.interfaces';

@Component({
  standalone: false,
  selector: 'gh-grid-single-selector',
  template: `
    <mat-radio-button *ngIf="!shouldHide"
                      color="primary"
                      [name]="name"
                      [disabled]="!selectable"
                      [checked]="checked"
                      (change)="onChange()"></mat-radio-button>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridSingleSelectorComponent implements OnInit, OnDestroy, GridCellRendererComponent, GridSelector {
  id: any;
  node: RowNode;
  name = uniqueId('single-selector:');
  private selection: GridSelection;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    this.refreshSelection = this.refreshSelection.bind(this);
  }

  get checked(): boolean {
    return this.selection.isSelected(this.id);
  }

  get shouldHide(): boolean {
    return !!(this.selection.shouldHidePinnedBottomRow && this.selection.shouldHidePinnedBottomRow(this.node));
  }

  get selectable(): boolean {
    return this.selection.isSelectable(this.node.data);
  }

  ngOnInit(): void {
    this.selection.addSelector(this.id, this);
  }

  ngOnDestroy(): void {
    this.selection.removeSelector(this.id);
    this.node.removeEventListener('dataChanged', this.refreshSelection);
  }

  agInit(params: any): void {
    this.selection = params.selection;
    this.id = params.node.id;
    this.node = params.node;

    this.node.addEventListener('dataChanged', this.refreshSelection);
  }

  refresh(params: any): boolean {
    this.changeDetectorRef.markForCheck();
    return true;
  }

  refreshSelection(): void {
    this.changeDetectorRef.markForCheck();
  }

  onChange(): void {
    this.selection.select(this.id, true);
  }
}
